import React from "react";
import Loader from "assets/images/loader.webp";

const Loading = ({ className }) => (
    <div className={`w-full h-full top-0 left-0 right-0 z-30 bg-black bg-opacity-50 flex justify-center items-center ${className}`}>
        <img className="w-16 h-16" src={Loader} alt="Loading" />
    </div>
);

export default Loading;
